export default __webpack_public_path__ + "static/media/user-management-white.eebe4235.svg";